import { ApiResponse, MenuCategoryMaster } from 'models';
import axiosClient from 'utils/axiosClient';

const ROOT_API_ROUTE = '/menu-category-masters';

const menuCategoryMasterService = {
  getAll(payload: { businessType?: string }): Promise<ApiResponse<MenuCategoryMaster[]>> {
    let url = ROOT_API_ROUTE;
    const type: string = payload.businessType === 'all' ? '' : `?type=${payload.businessType}`;
    return axiosClient.get(`${url}${type}`);
  },
};

export default menuCategoryMasterService;
